import { FormattedDate } from 'react-intl';
import styled from 'styled-components';

import { LabelL } from '@sorare/core/src/atoms/typography';

const Wrapper = styled.div`
  background: var(--gameweek-date-bg, var(--c-white));
  padding: 2px var(--intermediate-unit);
  border-radius: var(--half-unit);
`;

const Text = styled(LabelL)`
  color: var(--gameweek-date-color, var(--c-black));
`;

type Props = {
  startDate: Date;
  endDate: Date;
  className?: string;
};

export const GameweekDate = ({ startDate, endDate, className }: Props) => {
  return (
    <Wrapper className={className}>
      <Text bold>
        <FormattedDate value={startDate} month="short" day="numeric" /> -{' '}
        <FormattedDate value={endDate} month="short" day="numeric" />
      </Text>
    </Wrapper>
  );
};
